import { jsx as _jsx } from "react/jsx-runtime";
import { Banner } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { BASKET_CHANGED_STORAGE_KEY } from '../../../../constants/StorageKeysConstants';
import SessionStorageUtil from '../../../../util/SessionStorageUtil';
export const BasketMergedMessage = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const [basketsHaveMerged, setBasketsHaveMerged] = useState(false);
    useEffect(() => {
        const basketsHaveMergedCheck = SessionStorageUtil.getJsonItem(BASKET_CHANGED_STORAGE_KEY);
        if (basketsHaveMergedCheck) {
            SessionStorageUtil.removeItem(BASKET_CHANGED_STORAGE_KEY);
            setBasketsHaveMerged(basketsHaveMergedCheck);
        }
        else {
            setBasketsHaveMerged(false);
        }
    }, []);
    if (!basketsHaveMerged)
        return null;
    return _jsx(Banner, { status: "informative", text: t('basket.merged') });
};
